/**
 * PMS quick-link parameters arrive from a URL an outside vendor builds, and `query-string` returns
 * an **array** for a repeated key. Every one of these values is then used as a string — compared,
 * lowercased, trimmed — so a duplicated param throws during render, and there is no error boundary
 * in the app to catch it.
 *
 * Take the first occurrence and guarantee a string.
 */
export const readPmsParam = value => {
  const first = Array.isArray(value) ? value[0] : value

  return first == null ? '' : String(first)
}

const PMS_PARAM_KEYS = [
  'action',
  'PatientFirstName',
  'PatientLastName',
  'PatientBirthDate',
  'PatientID',
  'GrinPatientID',
  'PatientName',
  'source',
  'pms',
  // Which of the vendor's two Grin apps built this link. Greyfinch publishes us twice — the listed app
  // and an unlisted beta — and their patient mappings live in separate namespaces, so the link-back has
  // to be written as the same app whose launcher was clicked.
  'app'
]

export const readPmsParams = (queryParams = {}) =>
  PMS_PARAM_KEYS.reduce(
    (params, key) => (key in queryParams ? { ...params, [key]: readPmsParam(queryParams[key]) } : params),
    {}
  )
